import { createApp } from 'vue'
import App    from './App.vue'
import router from './router'
import { applyLocale } from './composables/useI18n'
import { applyTheme }  from './composables/useTheme'

// Apply persisted language (dir/lang) + theme before mount to avoid a flash.
applyLocale()
applyTheme()

createApp(App).use(router).mount('#app')
